interface Options {
  input: string;
  results: string;
  resultsContainer: string;
}

export function EmployeeSearch(opts: Options) {
  /**
   * First, collect all employees from the DOM (see `employees.php`)
   */
  const employees: Array<{ name: string; url: string }> = [];
  document.querySelectorAll('.employee').forEach((node) => {
    employees.push({
      name: node?.getAttribute('data-name') ?? '',
      url: node?.getAttribute('data-url') ?? '',
    });
  });

  const inputElement = $<HTMLInputElement>(opts.input);
  const resultsElement = $<HTMLUListElement>(opts.results);
  const resultsContainerElement = $<HTMLUListElement>(opts.resultsContainer);

  // Add an event listener to the input element
  inputElement.on('input', function () {
    const inputValue = $(this).val() as string;

    // Clear the container before rendering filtered options
    resultsElement.html('');

    //If there's text on input, we show the results list popdown
    if (inputValue.length > 0) {
      resultsContainerElement.show();

      // Filter and render options that match the search text
      const filteredOptions = employees.filter((option) => {
        //Split the input value by whitespace, so we can check if any of the given strings match the options
        const searchText = inputValue.split(' ');

        //Then we check each item if it's contained in any of the options
        //If one is found, the iteration below returns true
        return searchText.some((text) => {
          if (!text) {
            return false;
          }
          return (
            option.name.toLowerCase().indexOf(text.trim().toLowerCase()) !== -1
          );
        });
      });

      //If there are any results, inject the elements inside
      if (filteredOptions.length > 0) {
        filteredOptions.forEach((option) => {
          const optionElement = $('<a>')
            .attr('href', option.url)
            .append(option.name)
            .wrap('<li></li>')
            .parent();

          resultsElement.append(optionElement);
        });
      } else {
        //Otherwise, show a 'No data found' text
        const optionElement = $('<li>')
          .append('No data found')
          .css('pointer-events', 'none');

        resultsElement.append(optionElement);
      }
      return;
    }
    // Otherwise, hide the results section.
    resultsContainerElement.hide();
  });
}
